
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class VerticalIcon extends Vue {
  @Prop({ default: '13' }) readonly width?: string;
  @Prop({ default: '21' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
